'use client'

import React, { useEffect } from 'react'
import ReactGA from 'react-ga4'
import { useLocation } from 'react-router-dom'

const GOOGLE_ANALYTICS_ID: string | undefined = process.env.REACT_APP_PUBLIC_GOOGLE_ANALYTICS_ID
if (typeof GOOGLE_ANALYTICS_ID === 'string') {
  ReactGA.initialize(GOOGLE_ANALYTICS_ID)
  console.log('ReactGA initialized', GOOGLE_ANALYTICS_ID)
} else {
  ReactGA.initialize('test', { testMode: true })
}

export default function GoogleAnalyticsWrapper({ children }: { children: React.ReactElement }) {
  const location = useLocation()

  useEffect(() => {
    try {
      ReactGA.send({ hitType: 'pageview', page: `${location.pathname}` })
      console.log('GA pageview fired', `${location.pathname}`)
    } catch (error) {
      console.log(error)
    }
  }, [location.pathname])

  return <div>{children}</div>
}
